import CustomCard from '../../../../components/CustomCard';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
/**
 * StatusCard is a reusable UI component that renders a styled MUI Card.
 * It optionally displays a header, a body, and a divider between them.
 *
 * @component
 * @param {object} props
 * @param {React.ReactNode} [props.header=null] - Content to render at the top of the card.
 * @param {React.ReactNode} [props.body=null] - Main content of the card, rendered below the header (and divider, if enabled).
 * @param {boolean} [props.showDivider=false] - Whether to show a divider line between the header and body.
 * @param {string} [props.classes=''] - Additional CSS classes to apply to the Card component.
 * @param {string} [props.classContent=''] - Additional CSS classes to apply to the CardContent component.
 */
const  StatusCard = ({ content, classes = '', classContent = '', classCard= '' }) => {
    return (

        <CustomCard
            classCard={`card-border-8px ${classCard}`}
            classContent={`py-2 ${classContent}`}
            classes={classes}
        >
            {content.HEADER && <div className="row my-2">{content.HEADER}</div>}
             {content.DIVIDER && <div className={'border-bottom-shades-300'} />}
            <div className="mx-3">{content.BODY}</div>
        </CustomCard>
    );
};

export default StatusCard;
